/**
 * Utility function to get user email addresses by role name from user contacts
 * @param {Object} userContacts - The user contacts object from useUserContact hook
 * @param {Object} projectDetails - The project details containing role assignments
 * @returns {Array} Array of user objects with email addresses and display names
 */
export const getUserEmailByRole = (userContacts, projectDetails) => {
    if (!userContacts || !projectDetails) return [];

    const projectTeamMembers = [];

    const rolesToCheck = [
        { role: "SalesRep", label: "Sales Representative", key: "sales" },
        { role: "ProjectManager", label: "Project Manager", key: "projectManager" },
        { role: "MechanicalEngineer", label: "Mechanical Engineer", key: "mechanicalEngineer" },
        { role: "ElectricalEngineer", label: "Electrical Engineer", key: "electricalEngineer" },
        { role: "ControlsEngineer", label: "Controls Engineer", key: "controlsEngineer" }
    ];

    rolesToCheck.forEach(({ role, key, label }) => {
        const roleName = projectDetails[role];
        if (roleName && roleName !== "BLANK" && roleName !== "") {
            const contactList = userContacts[key] || [];
            const matchedContact = contactList.find(contact => contact.name === roleName);
            if (matchedContact) {
                projectTeamMembers.push({
                    role: label,
                    displayName: matchedContact.name,
                    email: matchedContact.email
                });
            }
        }
    });

    return projectTeamMembers;
};

/**
 * Extract emails from project team members array
 * @param {Array} projectTeamMembers - Array of project team member objects
 * @returns {Array} Array of email strings
 */
export const extractEmailsFromProjectTeam = (projectTeamMembers) => {
    return projectTeamMembers.map(member => member.email).filter(email => email && email !== 'N/A');
};
